import { Splide } from '@splidejs/splide';

/**
 * SlidePoints
 * 強みパネルの Point 群を「SP=スワイプスライダー / PC=destroyして2×2グリッド」に切り替える。
 * Splide の mediaQuery:'min' ＋ breakpoints{768:{destroy:true}} で、≥768 では破棄され素のDOMに戻る
 * （PCの2×2グリッドはCSS側 .splide__list で当てる）。複数インスタンス対応。
 *
 * @example
 * <div class="p-strength-points splide js-slide-points">
 *   <div class="splide__track"><ul class="splide__list">
 *     <li class="splide__slide">…Point…</li> …
 *   </ul></div>
 * </div>
 */
export default class SlidePoints {
  constructor(options = {}) {
    this.selector = options.selector || '.js-slide-points';
    document.querySelectorAll(this.selector).forEach((el) => this.setup(el));
  }

  /**
   * @param {HTMLElement} el
   */
  setup(el) {
    try {
      const splide = new Splide(el, {
        mediaQuery: 'min',
        type: 'loop',
        perPage: 1,
        gap: '2.4rem',           // カード間24px
        padding: { right: '6.9rem' }, // 右に69px余白＝次カードがチラ見（枠343で1枚274px相当）
        arrows: true,            // 前/次アロー（右下）
        pagination: false,       // ドットは出さない（デザインはアローのみ）
        drag: true,
        breakpoints: {
          768: { destroy: true }, // ≥768 はスライダー解除（CSSで2×2グリッド）
        },
      });
      splide.mount();
    } catch (error) {
      console.error('SlidePoints: Failed to initialize Splide', error);
    }
  }
}
